import React, {useState} from 'react'

import {$isCodeNode} from '@lexical/code'
import {
    $getNearestNodeFromDOMNode,
    $getSelection,
    $setSelection,
    LexicalEditor,
} from 'lexical'

import {useDebounce} from '../../utils'
import ControlButtonStandard from "../../../../../../buttons/control-button/control-button-standard"

interface Props {
    editor: LexicalEditor;
    getCodeDOMNode: () => HTMLElement | null;
}

export function CopyButton({editor, getCodeDOMNode}: Props) {
    const [isCopyCompleted, setCopyCompleted] = useState<boolean>(false);

    const removeSuccessIcon = useDebounce(() => {
        setCopyCompleted(false);
    }, 1000);

    async function handleClick(): Promise<void> {
        const codeDOMNode = getCodeDOMNode();

        if (!codeDOMNode) {
            return;
        }

        let content = '';

        editor.update(() => {
            const codeNode = $getNearestNodeFromDOMNode(codeDOMNode);

            if ($isCodeNode(codeNode)) {
                content = codeNode.getTextContent();
            }

            const selection = $getSelection();
            $setSelection(selection);
        });

        try {
            await navigator.clipboard.writeText(content);
            setCopyCompleted(true);
            removeSuccessIcon();
        } catch (err) {
            console.error('Failed to copy: ', err);
        }
    }

    const iconClasses = Classes({
        'i5-done'   : isCopyCompleted,
        'i5-copy'   : !isCopyCompleted
    })

    return <ControlButtonStandard  iconClass    = {iconClasses}
                                   hint         = "Copy code"
                                   onClick      = {handleClick}/>
}
